var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValveBoxTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_14",
    x: 0.3,
    y: 0,
    width: 40,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_384",
    x: 0,
    y: 8.9,
    width: 42,
    height: 24.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VALVE_BOX",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_14)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_14-2",
    "data-name": "Vereinigungsmenge 14",
    fill: "#f5f5f5",
    d: "M4230.8-2848.6h2a15.893,15.893,0,0,0,15.6,12.6,16,16,0,0,0,14.1-8.4h2.2a17.941,17.941,0,0,1-16.3,10.4A17.848,17.848,0,0,1,4230.8-2848.6Zm-.1-6.8a18.036,18.036,0,0,1,17.7-14.6,17.941,17.941,0,0,1,16.3,10.4h-2.2a16.124,16.124,0,0,0-14.1-8.4,16.172,16.172,0,0,0-15.7,12.6Z",
    transform: "translate(-4227.4 2873)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_384)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_384-2",
    "data-name": "Pfad 384",
    className: "cls-1",
    d: "M36,16.8v-1H27.1V13.4h8.4v-1H27.1V8.9H8.9v7.9H0v1.5H8.9V27H27.1V23.5h8.4v-1H27.1V20.1H36v-1H27.1V16.7H36ZM10.6,25.6l7.5-7.5-7.6-7.6H25.7v.1L18.1,18l7.5,7.5h-15Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValveBoxTool);
export default __webpack_public_path__ + "static/media/valve-box-tool.6bbbedc3fb74bc6bb649ab6cf902eb90.svg";
export { ForwardRef as ReactComponent };